// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"82":"dd94fcdc","213":"20029030","247":"7e88e2de","455":"d579405f","627":"147b9256","653":"155cb148","834":"e8d8e19c","867":"e86cf910","923":"a4ce0591","938":"6c757551"}[chunkId] + ".chunk.js";
};